import './target-free-number.ajscss';

import { hasChange } from '@commons/util/helper/helper';
import { IChangesObject, IComponentController, IComponentOptions } from 'angular';

import { Configuration, Option, PhoneValidationService } from '@contact/upgrade';

import templateUrl from './target-free-number.html';

const MODULE_NAME = 'transferTargetNumber';

class TransferTargetFreeNumberCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventTargetChange: Function;
  public rejected: boolean;

  // internal properties
  public targetFreeNumber: string;
  public valid: boolean;
  public phonePattern: string;

  constructor(private readonly configuration: Configuration, private readonly phoneValidation: PhoneValidationService) {
    this.rejected = false;
    this.valid = true;
    this.phonePattern = Option.of(this.configuration.phoneInputPattern).getOrElse('\\d+');
  }

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // rejected changed
    if (hasChange(changesObj['rejected'])) {
      this.rejected = changesObj['rejected'].currentValue;
    }
  }

  phoneNumberValid(): boolean {
    return this.phoneValidation.isValid(this.targetFreeNumber);
  }

  onTargetChange(): void {
    this.valid = this.phoneNumberValid();
    if (this.valid) {
      this.eventTargetChange({ $event: { target: this.targetFreeNumber } });
    } else {
      this.eventTargetChange({ $event: { target: undefined } });
    }
  }
}

export class TransferTargetFreeNumber implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    rejected: '<',
    eventTargetChange: '&',
  } as { [binding: string]: string };
  controller = ['configuration', TransferTargetFreeNumberCtrl];
}

export default MODULE_NAME;
